import {
  LinkPreviewProviders,
  WixRicosViewer,
  pluginCodeBlockViewer as pluginCodeBlock,
  pluginEmojiViewer as pluginEmoji,
  pluginHashtagViewer as pluginHashtag,
  pluginIndentViewer as pluginIndent,
  pluginLineSpacingViewer as pluginLineSpacing,
  pluginSpoilerViewer as pluginSpoiler,
} from '@wix/ricos'
import {
  pluginAudioLoadable as pluginAudio,
  pluginCollapsibleListLoadable as pluginCollapsibleList,
  pluginDividerLoadable as pluginDivider,
  pluginFileUploadLoadable as pluginFileUpload,
  pluginGalleryLoadable as pluginGallery,
  pluginGiphyLoadable as pluginGiphy,
  pluginHtmlLoadable as pluginHtml,
  pluginImageLoadable as pluginImage,
  pluginLinkLoadable as pluginLink,
  pluginLinkPreviewLoadable as pluginLinkPreview,
  pluginVideoLoadable as pluginVideo,
} from '@wix/ricos/loadable'
import {EVENTS_APP_ID, ExperimentNames} from '@wix/wix-events-commons-statics'
import {useEnvironment, useExperiments} from '@wix/yoshi-flow-editor'
import React, {ComponentProps} from 'react'
import {useAppSelector} from '../../../hooks/runtime'
import {getEvent} from '../../../selectors/event'
import {RicosViewerProps} from './interfaces'
import '@wix/ricos/css/ricos-viewer.global.css'
import '@wix/ricos/css/plugin-hashtag-viewer.global.css'
import '@wix/ricos/css/plugin-spoiler-viewer.global.css'

export const RicosViewer = ({content}: RicosViewerProps) => {
  const {isMobile} = useEnvironment()
  const eventId = useAppSelector(state => getEvent(state).id)
  const instance = useAppSelector(state => state.instance.instance)
  const msid = useAppSelector(state => state.instance.msid)
  const {experiments} = useExperiments()

  const aboutSectionSettingsEnabled = experiments.enabled(ExperimentNames.AboutSectionSettings)

  return (
    <WixRicosViewer
      content={content}
      instance={instance}
      msid={msid}
      plugins={plugins}
      theme={aboutSectionSettingsEnabled ? theme : oldTheme}
      isMobile={isMobile}
      biSettings={{consumer: 'Events', postId: eventId, containerId: EVENTS_APP_ID, platform: 'Livesite'}}
    />
  )
}

const plugins = [
  pluginAudio(),
  pluginCodeBlock(),
  pluginCollapsibleList(),
  pluginDivider(),
  pluginEmoji(),
  pluginFileUpload(),
  pluginGallery(),
  pluginGiphy(),
  pluginHashtag(),
  pluginHtml(),
  pluginImage(),
  pluginIndent(),
  pluginLineSpacing(),
  pluginLink(),
  pluginLinkPreview({
    exposeEmbedButtons: [LinkPreviewProviders.Instagram, LinkPreviewProviders.Twitter, LinkPreviewProviders.TikTok],
  }),
  pluginSpoiler(),
  pluginVideo(),
]

const theme: ComponentProps<typeof WixRicosViewer>['theme'] = {
  useWixStyles: true,
  typography: {
    fontFamily: 'var(--aboutSectionFontV2-family)',
  },
  palette: {
    type: 'rgb',
    actionColor: 'var(--linkColorV2)',
    textColor: 'var(--aboutSectionColorV2)',
  },
}

const oldTheme: ComponentProps<typeof WixRicosViewer>['theme'] = {
  useWixStyles: true,
  typography: {
    fontFamily: 'var(--textFontV2-family)',
  },
  palette: {
    type: 'rgb',
    actionColor: 'var(--linkColorV2)',
    textColor: 'var(--textColorV2)',
  },
}
